import { IN_APP } from '../inApp'

// Inside the phone app (which says so with window.ASYS_NATIVE_SCAN), the
// phone's own scanner reads barcodes for the web pages: a page asks with
// {type: 'asys:scan'} and gets an 'asys:scan-result' event back, with
// {code} or {cancelled: true} (asys-mobile components/WebScreen.tsx).
export const phoneScans = () => Boolean(IN_APP && typeof window !== 'undefined' && window.ASYS_NATIVE_SCAN && window.ReactNativeWebView)

/** Ask the phone's scanner for one code: onCode(code), or onCode('') when
    the scan is cancelled. Returns a function that stops waiting. */
export function askPhoneToScan(onCode) {
  const onResult = (e) => {
    window.removeEventListener('asys:scan-result', onResult)
    onCode(String(e.detail?.code || '').trim())
  }
  window.addEventListener('asys:scan-result', onResult)
  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'asys:scan' }))
  return () => window.removeEventListener('asys:scan-result', onResult)
}
